import { IPublicTypeDragNodeDataObject, IPublicTypeDragNodeObject, IPublicTypeDragAnyObject } from './';

// eslint-disable-next-line max-len
export type IPublicTypeDragObject = IPublicTypeDragNodeObject | IPublicTypeDragNodeDataObject | IPublicTypeDragAnyObject;
